import React, { useEffect, useState } from 'react'

import Footer from './Footer'
import Header from './Header'
import { RefinanceIndex } from './RefinanceIndex'
import apiEndpoint from '../services/api'
import axiosClient from '../services/AxiosClient'
import { EmptyObj, RefinanceIndexDTO } from '../store/StateObjects'

import '../styles/App.css'

const App: React.FC = () => {
  const [data, setData] = useState<RefinanceIndexDTO>(EmptyObj)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = apiEndpoint()
        const result = await axiosClient.get(url)
        setData(result?.data)
      } catch (error) {
        setHasError(true)
      }
    }

    fetchData()
  }, [])

  return (
    <div className="App">
      <Header />
      <RefinanceIndex refiObj={data} hasError={hasError} />
      <Footer />
    </div>
  )
}

export default App
